module.exports = {
  "backgroundSize": {
    "auto": "auto",
    "cover": "cover",
    "contain": "contain"
  },
  "backgroundPosition": {
    "bottom": "bottom",
    "center": "center",
    "left": "left",
    "left-bottom": "left bottom",
    "left-top": "left top",
    "right": "right",
    "right-bottom": "right bottom",
    "right-top": "right top",
    "top": "top"
  },
  "borderRadius": {
    "1": "1px",
    "2": "2px",
    "4": "4px",
    "6": "6px",
    "8": "8px",
    "12": "12px",
    "16": "16px",
    "none": "0",
    "full": "100%"
  },
  "borderWidth": {
    "0": "0",
    "1": "1px",
    "2": "2px",
    "default": "1px"
  },
  "boxShadow": {
    "none": "none"
  },
  "cursor": {
    "auto": "auto",
    "default": "default",
    "pointer": "pointer",
    "wait": "wait",
    "text": "text",
    "move": "move",
    "copy": "copy",
    "not-allowed": "not-allowed"
  },
  "flex": {
    "1": "1 1 0%",
    "auto": "1 1 auto",
    "initial": "0 1 auto",
    "none": "none"
  },
  "flexGrow": {
    "0": "0",
    "default": "1"
  },
  "flexShrink": {
    "0": "0",
    "default": "1"
  },
  "fontSize": {
    "10": "1rem",
    "11": "1.1rem",
    "12": "1.2rem",
    "13": "1.3rem",
    "14": "1.4rem",
    "16": "1.6rem",
    "20": "2rem",
    "32": "3.2rem",
    "40": "4rem",
    "56": "5.6rem",
    "72": "7.2rem"
  },
  "fontWeight": {
    "300": "300",
    "400": "400",
    "500": "500",
    "600": "600",
    "700": "700",
    "regular": "400",
    "medium": "500",
    "semibold": "600",
    "bold": "700"
  },
  "lineHeight": {
    "none": "1",
    "tight": "1.25",
    "normal": "1.5",
    "loose": "2"
  },
  "letterSpacing": {
    "tight": "-0.025em",
    "normal": "0",
    "wide": "0.025em"
  },
  "listStyleType": {
    "none": "none",
    "disc": "disc",
    "decimal": "decimal"
  },
  "objectPosition": {
    "bottom": "bottom",
    "center": "center",
    "left": "left",
    "left-bottom": "left bottom",
    "left-top": "left top",
    "right": "right",
    "right-bottom": "right bottom",
    "right-top": "right top",
    "top": "top"
  },
  "opacity": {
    "0": "0",
    "5": "0.05",
    "7": "0.07",
    "10": "0.1",
    "12": "0.12",
    "15": "0.15",
    "20": "0.2",
    "30": "0.3",
    "40": "0.4",
    "50": "0.5",
    "60": "0.6",
    "70": "0.7",
    "80": "0.8",
    "90": "0.9",
    "100": "1"
  },
  "zIndex": {
    "0": "0",
    "10": "10",
    "20": "20",
    "30": "30",
    "40": "40",
    "50": "50",
    "auto": "auto"
  },
  "height": {
    "0": "0",
    "1": "0.40rem",
    "2": "0.80rem",
    "3": "1.20rem",
    "4": "1.60rem",
    "5": "2.40rem",
    "6": "3.20rem",
    "7": "4.00rem",
    "8": "4.80rem",
    "auto": "auto",
    "1.5": "0.60rem",
    "full": "100%",
    "screen": "100vh"
  },
  "spacing": {
    "0": "0",
    "1": "0.40rem",
    "2": "0.80rem",
    "3": "1.20rem",
    "4": "1.60rem",
    "5": "2.40rem",
    "6": "3.20rem",
    "7": "4.00rem",
    "8": "4.80rem",
    "1.5": "0.60rem"
  },
  "width": {
    "0": "0",
    "1": "0.40rem",
    "2": "0.80rem",
    "3": "1.20rem",
    "4": "1.60rem",
    "5": "2.40rem",
    "6": "3.20rem",
    "7": "4.00rem",
    "8": "4.80rem",
    "auto": "auto",
    "1.5": "0.60rem",
    "1/2": "50%",
    "1/3": "33.333333%",
    "2/3": "66.666667%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
    "1/5": "20%",
    "2/5": "40%",
    "3/5": "60%",
    "4/5": "80%",
    "1/12": "8.333333%",
    "2/12": "16.666667%",
    "3/12": "25%",
    "4/12": "33.333333%",
    "5/12": "41.666667%",
    "6/12": "50%",
    "7/12": "58.333333%",
    "8/12": "66.666667%",
    "9/12": "75%",
    "10/12": "83.333333%",
    "11/12": "91.666667%",
    "full": "100%",
    "screen": "100vw"
  },
  "margin": {
    "0": "0",
    "1": "0.40rem",
    "2": "0.80rem",
    "3": "1.20rem",
    "4": "1.60rem",
    "5": "2.40rem",
    "6": "3.20rem",
    "7": "4.00rem",
    "8": "4.80rem",
    "auto": "auto",
    "1.5": "0.60rem",
    "-1": "-0.40rem",
    "-2": "-0.80rem",
    "-3": "-1.20rem",
    "-4": "-1.60rem",
    "-5": "-2.40rem",
    "-6": "-3.20rem",
    "-7": "-4.00rem",
    "-8": "-4.80rem",
    "-1.5": "-0.60rem"
  },
  "padding": {
    "0": "0",
    "1": "0.40rem",
    "2": "0.80rem",
    "3": "1.20rem",
    "4": "1.60rem",
    "5": "2.40rem",
    "6": "3.20rem",
    "7": "4.00rem",
    "8": "4.80rem",
    "1.5": "0.60rem"
  },
  "maxHeight": {
    "full": "100%",
    "screen": "100vh"
  },
  "minHeight": {
    "0": "0",
    "full": "100%",
    "screen": "100vh"
  },
  "maxWidth": {
    "full": "100%",
    "screen": "100vw"
  },
  "minWidth": {
    "0": "0",
    "full": "100%"
  },
  "colors": {
    "charcoal": "#0A0A14",
    "white": "#FFFFFF",
    "transparent": "transparent",
    "space": "#0828CC",
    "water": "#F8F8FD",
    "powder": "#EFEFF8",
    "azure": "#E6E9F9",
    "ash": "#D7D7E0",
    "fossil": "#A9A9B2",
    "anchor": "#73737D",
    "pebble": "#8E8E93",
    "slate": "#646469",
    "graphite": "#48484C",
    "lead": "#3A3A3E",
    "obsidian": "#2C2C2F",
    "smoke": "#1C1C1F",
    "stone": "#141416"
  },
  "backgroundColor": {},
  "textColor": {},
  "placeholderColor": {},
  "borderColor": {},
  "fill": {
    "current": "currentColor"
  },
  "stroke": {
    "current": "currentColor"
  },
  "app": {
    "header": "#0A0A14",
    "header-tab": "rgba(255, 255, 255, 0.1)",
    "header-tab-hover": "rgba(255, 255, 255, 0.2)",
    "header-text": "rgba(255, 255, 255, 0.6)",
    "header-text-hover": "#FFFFFF"
  },
  "cht": {
    "bg": "#F3EAE1",
    "border": "#E6D4CA",
    "bubble": "#EBEBFF",
    "bubble-border": "#C7D3F7",
    "bubble-icon-1": "#73737D",
    "bubble-icon-2": "#D7D7E0",
    "bubble-icon-3": "#0828CC",
    "bubble-insert": "#F8F8FD",
    "bubble-link": "#0828CC",
    "bubble-text": "#73737D",
    "reply": "#FFFFFF",
    "footer": "#F3EAE1",
    "hover": "rgba(115, 115, 125, 0.07)",
    "read": "#16AAD2",
    "unread": "#A9A9B2"
  },
  "spr": {
    "ui-01": "#FFFFFF",
    "ui-02": "#F8F8FD",
    "ui-03": "#EFEFF8",
    "ui-04": "#0828CC",
    "ui-focus": "rgba(8, 40, 204, 0.07)",
    "ui-focus-reverse": "rgba(255, 255, 255, 0.2)",
    "ui-hover": "rgba(8, 40, 204, 0.05)",
    "ui-hover-reverse": "rgba(255, 255, 255, 0.1)",
    "support-error": "#ff6060",
    "support-success": "#3fbf41",
    "support-warning": "#EEC202",
    "tag": "#EFEFF8",
    "field": "#D7D7E0",
    "popup": "#FFFFFF",
    "overlay": "rgba(10, 10, 20, 0.9)",
    "tooltip-01": "rgba(10, 10, 20, 0.9)",
    "placeholder": "#EFEFF8",
    "highlight": "rgba(255, 231, 173, 0.7)",
    "favourite": "#FF9F21",
    "notification": "#E44045",
    "icon-01": "#0A0A14",
    "icon-02": "#73737D",
    "icon-03": "#A9A9B2",
    "icon-04": "#0828CC",
    "icon-05": "#FFFFFF",
    "icon-06": "rgba(255, 255, 255, 0.6)",
    "icon-hover": "#0A0A14",
    "icon-disable": "#D7D7E0",
    "icon-hover-06": "#FFFFFF",
    "link": "#0828CC",
    "text-01": "#0A0A14",
    "text-02": "#73737D",
    "text-03": "#A9A9B2",
    "text-04": "#0828CC",
    "text-05": "#FFFFFF",
    "text-06": "#FFFFFF",
    "support-error-text": "#E44045",
    "support-success-text": "#20963a",
    "support-warning-text": "#DEAC09",
    "hover": "#0828CC",
    "focus": "#0828CC",
    "border-01": "#EFEFF8",
    "border-02": "#E6E9F9",
    "border-03": "#D7D7E0",
    "card-border": "#E6E9F9",
    "popup-border": "#D7D7E0",
    "tooltip-border": "#0A0A14",
    "interactive-01": "#0828CC",
    "interactive-focus": "#132a86",
    "interactive-disable": "rgba(255, 255, 255, 0.8)",
    "interactive-hover": "#0729a0",
    "interactive-02": "#73737D",
    "card-shadow": "0 2px 8px 0 rgba(10, 10, 20, 0.2)",
    "popup-shadow": "0 2px 8px 0 rgba(10, 10, 20, 0.2)",
    "drawer-shadow": "-2px 9px 12px 0 rgba(10,10,20,0.60)"
  },
  "nav": {
    "ui-01": "rgba(255, 255, 255, 0.2)",
    "ui-hover-01": "rgba(255, 255, 255, 0.3)",
    "icon-01": "rgba(255, 255, 255, 0.9)",
    "icon-focus-01": "#DE456B",
    "text-01": "rgba(255, 255, 255, 0.9)",
    "shadow-01": "-2px 2px 12px 0px rgba(10, 10, 20, 0.6)"
  }
}; 
